import type { ComponentSchema } from "../../../../../schema-types"

const RADIUS_OPTIONS = [
  { label: 'None', value: '0px' },
  { label: 'Small', value: '4px' },
  { label: 'Medium', value: '8px' },
  { label: 'Large', value: '12px' },
  { label: 'XL', value: '16px' },
  { label: 'Pill', value: '9999px' },
]

const HEIGHT_OPTIONS = [
  { label: 'XS — 32px', value: '32px' },
  { label: 'SM — 36px', value: '36px' },
  { label: 'MD — 40px', value: '40px' },
  { label: 'Default — 44px', value: '44px' },
  { label: 'LG — 48px', value: '48px' },
  { label: 'XL — 56px', value: '56px' },
]

const PADDING_X_OPTIONS = [
  { label: 'XS — 8px', value: '8px' },
  { label: 'SM — 12px', value: '12px' },
  { label: 'MD — 16px', value: '16px' },
  { label: 'Default — 20px', value: '20px' },
  { label: 'LG — 24px', value: '24px' },
  { label: 'XL — 32px', value: '32px' },
  { label: 'XXL — 40px', value: '40px' },
]

export const schema: ComponentSchema = {
  type: 'buttons',
  label: 'Buttons',
  description: 'Global button styles applied across the entire theme. Per-section buttons can override the label and background.',
  supportedPages: [],
  variants: [{ id: 'v1', label: 'Default' }],
  commonFields: [
    {
      key: 'appearance.buttons.primary',
      label: 'Primary Button',
      type: 'object',
      preview: { type: 'button', variant: 'primary', defaultLabel: 'Order Now' },
      fields: [
        { key: 'bg', label: 'Background Color', type: 'color' },
        { key: 'hoverBg', label: 'Hover Background', type: 'color' },
        { key: 'text', label: 'Text Color', type: 'color' },
        { key: 'radius', label: 'Border Radius', type: 'select', options: RADIUS_OPTIONS, default: '12px' },
        { key: 'height', label: 'Height', type: 'select', options: HEIGHT_OPTIONS, default: '44px' },
        { key: 'paddingX', label: 'Horizontal Padding', type: 'select', options: PADDING_X_OPTIONS, default: '20px' },
        { key: 'label', label: 'Default Text', type: 'string', placeholder: 'অর্ডার করুন' },
      ],
    },
    {
      key: 'appearance.buttons.outline',
      label: 'Outline Button',
      type: 'object',
      preview: { type: 'button', variant: 'outline', defaultLabel: 'Add to Cart' },
      fields: [
        { key: 'borderColor', label: 'Border Color', type: 'color' },
        { key: 'hoverBg', label: 'Hover Background', type: 'color' },
        { key: 'text', label: 'Text / Icon Color', type: 'color' },
        { key: 'radius', label: 'Border Radius', type: 'select', options: RADIUS_OPTIONS, default: '12px' },
        { key: 'height', label: 'Height', type: 'select', options: HEIGHT_OPTIONS, default: '44px' },
        { key: 'paddingX', label: 'Horizontal Padding', type: 'select', options: PADDING_X_OPTIONS, default: '20px' },
        { key: 'label', label: 'Default Text', type: 'string', placeholder: 'Add to Cart' },
      ],
    },
  ],
}
